import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Box, Link, Typography } from "@mui/material";
import StatusUpdateCard from "./StatusUpdateCard";
import { Routes } from "Utils/Constants";
import useSession from "Utils/Hooks/useSession";
import useView, { VIEW } from "Utils/Hooks/useView";
import { useHistory } from "react-router-dom";
import { Button } from "@pav/pav-products-design-system";
import { useVipAccountCache } from "context/VipAccountContext";

export default function AddAccountSuccess({
  successTitle = "Bank Account Added",
  successMsg = "You've successfully added an account.",
  removeAccount,
  bankManagementMode,
}) {
  const { session, invalidateSession } = useSession();
  const { setVipAccount } = useVipAccountCache();
  const history = useHistory();
  const view = useView();
  const isCashier = view === VIEW.cashier;
  const customButtons = [
    {
      label: "Manage Funding Sources",
      route: Routes.MY_ACCOUNTS,
      style: "secondary",
    },
    {
      label: "Done",
      route: undefined,
      returnToOperator: true,
      returnUrl: session?.returnUrl,
      transactionId: session?.transactionId,
      transactionType: "bankManagement",
    },
  ];

  const customButtonsComponents = customButtons?.map((customButton, index) => {
    return (
      <Box sx={{ width: "100%", margin: "var(--spacing-lg) 0" }}>
        {isCashier
          ? null
          : session.returnUrl && (
              <Button
                fullWidth
                buttonType={
                  location.pathname === "/success" ||
                  customButton.style === "secondary"
                    ? "secondary"
                    : customButton.style === "primary"
                      ? "primary"
                      : customButton.zeroBal ||
                          customButton.label === "CANCEL" ||
                          customButton.label === "Add New Funding Source" ||
                          customButton.label === "Complete Deposit"
                        ? "secondary"
                        : "primary"
                }
                className={
                  customButton.zeroBal || customButton.label === "CANCEL"
                    ? "click-cancel"
                    : "submit-button click-return-to-opr"
                }
                onClick={() => {
                  customButton.returnToOperator
                    ? WcRedirect(customButton)
                    : history.push({
                        pathname: customButton.route,
                        state: { notRedirect: customButton.notRedirect },
                      });
                }}
              >
                {customButton.label}
              </Button>
            )}
      </Box>
    );
  });

  function WcRedirect(customButton) {
    if (customButton.returnUrl) {
      var queryStringSeperator = customButton.returnUrl.includes("?")
        ? "&"
        : "?";
      window.location.replace(
        customButton.returnUrl +
          queryStringSeperator +
          "transactionId=" +
          customButton.transactionId +
          "&transactionType=" +
          customButton.transactionType,
      );
    } else {
      if (window.opener !== null && !window.opener.closed) {
        window.close();
      } else if (
        window.parent !== null &&
        window.parent.frames !== null &&
        window.parent.frames.length > 0
      ) {
        window.parent.postMessage("close", "*");
      } else {
        if (/android/i.test(navigator.userAgent)) {
          if (typeof window !== undefined) {
            window.postMessage("close", "*");
          } else if (document !== undefined) {
            document.postMessage("close", "*");
          }
        } else if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
          window.postMessage("close", "*");
        }
      }
    }
    invalidateSession();
    setVipAccount(null);
  }
  return (
    <Box sx={{ width: "100%" }}>
      <StatusUpdateCard
        heading={successTitle}
        body={
          <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
            <Typography>{successMsg}</Typography>
            {removeAccount && (
              <Link
                onClick={removeAccount}
                sx={{
                  color: "var(--color-text-link)",
                  fontWeight: 700,
                  fontSize: "var(--body-size)",
                }}
              >
                Remove Account
              </Link>
            )}
          </Box>
        }
        icon={
          <CheckCircleIcon
            sx={{
              fontSize: "4rem",
              color: "var(--color-surface-icon-primary)",
            }}
          />
        }
      />
      {bankManagementMode && customButtonsComponents}
    </Box>
  );
}
